import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CreateScheduleContainer } from './create-schedule-container';
import { UpdateScheduleContainer } from './update-schedule-container';


export interface ScheduleReportSidebarData {
  reportId: string;
  reportName: string;
  scheduleId?: string;
}

interface ScheduleReportSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  data: ScheduleReportSidebarData;
}

export const ScheduleReportSidebar = ({ isOpen, onClose, data }: ScheduleReportSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        {data.scheduleId ? (
          <FormattedMessage id="predict.manage_report_schedule" defaultMessage="Manage report schedule" />
        ) : (
          <FormattedMessage id="predict.create_report_schedule" defaultMessage="Create report schedule" />
        )}
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    {data.scheduleId ? (
      <UpdateScheduleContainer
        onClose={onClose}
        reportId={data.reportId}
        reportName={data.reportName}
        scheduleId={data.scheduleId}
      />
    ) : (
      <CreateScheduleContainer
        onClose={onClose}
        reportId={data.reportId}
        reportName={data.reportName}
      />
    )}
  </Sidebar>
);
